<div class="modal-header">
  <h4 class="modal-title">
    <i class="fa" [ngClass]="titleIcon" *ngIf="titleIcon"></i>
    {{ title }}<span *ngIf="subtitle"> - {{ subtitle }}</span>
  </h4>
</div>

<div class="modal-body">
  <div class="form-horizontal" style="margin-top: 10px;">
    <form [formGroup]="formGroup" (ngSubmit)="confirm()">

      <div class="form-group" *ngFor="let row of summaryRows">
        <label class="col-sm-5 control-label">{{ row.label }}</label>
        <div class="col-sm-4">
          <p class="form-control-static">
            <span class="label" [ngClass]="row.labelClass || 'label-default'">{{ row.value }}</span>
          </p>
        </div>
      </div>

      <hr *ngIf="summaryRows.length" />

      <div class="form-group">
        <label class="col-sm-5 control-label">
          {{ quantityLabel }} <i class="required">*</i>
        </label>
        <div class="col-sm-4">
          <input class="form-control wcm-highlight-req"
                 [ngClass]="{ 'wcm-highlight-error': formGroup.controls.quantity.errors }"
                 formControlName="quantity"
                 type="number"
                 [min]="1"
                 [max]="maxQuantity"
                 [step]="1" />
          <span class="help-block">Maximum : {{ maxQuantity }}</span>
        </div>
      </div>

    </form>
  </div>
</div>

<div class="modal-footer">
  <button class="btn" [ngClass]="confirmButtonClass" [disabled]="formGroup.invalid" (click)="confirm()">
    {{ confirmLabel }}
  </button>
  <button class="btn btn-default" (click)="modal.dismiss()">
    {{ cancelLabel }}
  </button>
</div>
